import React from "react";
//====================================================================
// IMPORTANT: import from 'react-bricks/frontend' for Next.js with Pages Folder, Remix or Gatsby
// import from 'react-bricks/rsc' for Next.js with App Router (server components).
import { types, Text } from "react-bricks/rsc";
import styled from "styled-components";
import { getVerticalPadding, VerticalPadding, verticalPadSideProp } from "../utils/verticalPadding";
import Link from "next/link";
import { BetterButton } from "components/atoms/BetterButton";
import { useAdminContext } from "react-bricks";

interface ButtonStripProps {
  paddingVertical: VerticalPadding;
  link: string;
  label: string;
}

const ButtonStrip: types.Brick<ButtonStripProps> = ({ link, label, paddingVertical }) => {
  const { isAdmin } = useAdminContext();
  return (
    <Container vp={getVerticalPadding(paddingVertical)}>
      {isAdmin ? (
        <BetterButton text={label} />
      ) : (
        <Link href={link}>
          <BetterButton text={label} />
        </Link>
      )}
    </Container>
  );
};

ButtonStrip.schema = {
  // Unique brick name
  name: "buttonstrip",
  label: "Button Strip",
  previewImageUrl: "/static/bricks/button.png",
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    link: "#",
    label: "Click Me",
  }),

  // Sidebar Edit controls for props
  sideEditProps: [
    verticalPadSideProp,
    {
      name: "link",
      label: "Link",
      type: types.SideEditPropType.Text,
    },
    {
      name: "label",
      label: "Label",
      type: types.SideEditPropType.Text,
    },
  ],
};

export default ButtonStrip;

const Container = styled.div<{ vp: string }>`
  padding: ${(props) => props.vp} 0;
  align-items: center;
  button {
    margin: auto;
  }
`;
